import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { AdminProductQuantityHistoryReasonType } from '../../enums/admin-product-quantity-history-reason-type';
import { AdminProductQuantityHistoryOrderResponse } from './admin-product-quantity-history-order.response';

@jsonObject
export class AdminProductQuantityHistoryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Number)
  public readonly change!: number;

  @jsonMember(Number)
  public readonly quantityBeforeChange!: number;

  @jsonMember(Number)
  public readonly quantityAfterChange!: number;

  @jsonMember(String)
  public readonly reason!: AdminProductQuantityHistoryReasonType;

  @jsonMember(AdminProductQuantityHistoryOrderResponse)
  public readonly order?: Nillable<AdminProductQuantityHistoryOrderResponse>;

  @jsonMember(String)
  public readonly createdBy?: Nillable<string>;
}
